<template>
<b-row class="m-2">
    <b-col>
        <b-row>
            <b-col>
                <h1>Authentication Settings</h1>
            </b-col>
            <b-col class="text-right">
                <!--                <otif-button class=" OTSecondary">Cancel</otif-button>-->
                <otif-button class=" OTPrimary" @click.native="save" id="OTSaveSetting">Save</otif-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <p>
                    Select which mechanism to authenticate with.
                </p>
                <otif-radio :values="[{value: false, label: 'Use Local Users'}, {value: true, label: 'Use Opentext Directory Services'}]" label="Authentication Type" v-model="enable_otds"/>
            </b-col>
        </b-row>
        <OTDSConfiguration v-show="enable_otds" ref="otds"/>
        <Users v-show="!enable_otds"/>
    </b-col>
</b-row>
</template>

<script>

import axios from 'axios';
import OTDSConfiguration from './OTDSConfiguration.vue';
import Users from './UsersPage.vue';

export default {

    components: {
        OTDSConfiguration,
        Users
    },

    data() {
        return {
            rows: [[
                'admin',
                'admin@opentext.com',
                'Administrator'
            ],[
                'user',
                'user@opentext.com',
                'User'
            ]],
            columns: [{
                name: 'username',
                label: 'Username'
            },{
                name: 'email',
                label: 'Email Address'
            },{
                name: 'role',
                label: 'Role'
            }],
            resource: {
                otds_base_uri: '',
                otds_resource_id: '',
                otds_client_id: '',
                otds_client_secret: '',
                otds_admin_group: '',
                otds_enabled: ''
            },
            otds_loaded: false,
            enable_otds: false,
            status: null
        }
    },

    methods: {
        save() {
            this.$snotify.info('Saving');
            var resource = this.$refs['otds'].resource;
            resource['otds_enabled'] = this.enable_otds === false ? 'false' : 'true';
            axios.post('/mtm-gateway-api/v1/configuration/otds', resource)
            .then(() => {
                this.$snotify.clear();
                this.$snotify.success('Configuration saved');
            })
            .catch(() => {
                this.$snotify.clear();
                this.$snotify.error('An error occurred saving the configuration.');
            });
        },

        activate() {

            this.$snotify.info('Activating Resource', { timeout: 0 });

            axios.post('/mtm-gateway-api/v1/otds/resource/' + this.resource.otds_resource_id + '/activate')
            .then((res) => {
                return this.refresh_otds_status();
            })
            .catch((err) => {
                this.$snotify.clear();
                this.$snotify.error(err.response.data.detail, 'Error');
            });
        },

        deactivate() {

        },

        refresh_otds_status() {
            this.status = null;
            return axios.get('/mtm-gateway-api/v1/configuration/otds/status')
            .then((res) => {
                this.status = res.data;
            });
        },

        refresh_otds() {
            return axios.get('/mtm-gateway-api/v1/configuration/otds')
            .then((res) => {
                this.resource = res.data;
                this.otds_loaded = true;
                return this.refresh_otds_status();
            });
        }
    },

    mounted() {
        var breadcrumbs = [{
            name: 'settings',
            meta: { label: 'Settings' }
        },{
            name: 'security-settings',
            meta: { label: 'Authentication' }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        this.refresh_otds()
        .then(() => {
            if (this.resource.otds_enabled === 'true') {
                this.enable_otds = true;
            }
        });
    }

}

</script>
